export default "__VITE_ASSET__0UnaD7Yt__"